import Api from "js/core/api";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.ANALYTICS);

export const removePrefix = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
        if (key.indexOf(prefix) === 0) {
            obj[key.slice(3)] = obj[key];
            delete obj[key];
        }
    });
};

// Log audit event to backend for compliance tracking
export async function logAuditEvent(options, props, user) {
    if (!options.audit || !user) return;

    const pg_props = { ...props };
    removePrefix(pg_props, "pg_");

    delete pg_props.email;
    delete pg_props.affected_user_id;
    delete pg_props.presentationId;
    delete pg_props.workspace_id;
    pg_props.label = options.label;
    pg_props.value = options.value;

    const columns = {
        category: options.category,
        action: options.action,
        affected_user_id: props.pg_affected_user_id,
        presentation_id: props.presentationId,
        workspace_id: props.workspace_id,
        props: JSON.stringify(pg_props),
        email: user.email,
    };

    Api.audit.post({
        namespace: "analytics",
        action: null,
        props: columns
    }).catch(err => {
        logger.error(err, "Api.audit.post() failed");
    });
}
